import { render, staticRenderFns } from "./sendMail.vue?vue&type=template&id=eb4dc7fa&scoped=true&"
import script from "./sendMail.vue?vue&type=script&lang=js&"
export * from "./sendMail.vue?vue&type=script&lang=js&"
import style0 from "./sendMail.vue?vue&type=style&index=0&id=eb4dc7fa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb4dc7fa",
  null
  
)

export default component.exports